var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#CFCFCF",
    fill: "#FFF",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.975 22.1c0-.933-.076-1.872-.237-2.79H21.783v5.289H29.2a6.357 6.357 0 01-2.745 4.173v3.432h4.426c2.599-2.392 4.093-5.925 4.093-10.103z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.783 35.52c3.704 0 6.828-1.216 9.104-3.316l-4.426-3.432c-1.231.838-2.821 1.312-4.673 1.312-3.584 0-6.622-2.417-7.712-5.667H9.51v3.538a13.737 13.737 0 0012.274 7.565z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.071 24.417a8.227 8.227 0 010-5.259v-3.537H9.51a13.746 13.746 0 000 12.334l4.562-3.538z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.783 13.486a7.464 7.464 0 015.268 2.059l3.922-3.921a13.2 13.2 0 00-9.19-3.574 13.732 13.732 0 00-12.274 7.57l4.562 3.538c1.085-3.255 4.128-5.672 7.712-5.672z",
    fill: "#EA4335"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.4b05bb806d037f79298c3ce75047582b.svg";
export { ForwardRef as ReactComponent };